@if (showText()) {
  <span class="linked-text">
    @for (token of renderedTokens(); track $index) {
      @if (token.kind === 'link') {
        <a
          class="inline-link"
          [href]="token.href"
          target="_blank"
          rel="noopener noreferrer"
          referrerpolicy="no-referrer"
          >{{ token.label }}
          @if (token.showHostname) {
            <span class="link-host">({{ token.hostname }})</span>
          }
          <span class="visually-hidden"> (opens in a new tab)</span></a
        >
      } @else {
        {{ token.text }}
      }
    }
  </span>
}
@if (previews().length > 0) {
  <span class="link-previews" aria-label="Link previews">
    @for (preview of previews(); track preview.href) {
      <span class="link-preview" role="note">
        <span class="preview-kicker">{{ preview.kicker }}</span>
        <span class="preview-title">{{ preview.title }}</span>
        <span class="preview-url">{{ preview.displayUrl }}</span>
      </span>
    }
  </span>
}
